<template>
  <div class="navbar-wrap">
    <div class="navbar">
      <div class="navbar-left">
        <router-link class="logo-box" to="/">
          <img class="logo" src="../../../assets/images/logo_navbar_2.png" alt="衣加加云平台" title="衣加加云平台">
        </router-link>
        
        <div class="nav-item"  v-if="userType == 1" :class="{active:'/addOem,/addCmt'.search(currentPath)>-1}">
          <span>发布订单</span>
          <div class="dropdown">
            <div class="dropdown-inner">
              <div class="line" @click="toAddOrder('oem')" w-path="">包工包料订单</div>
              <div class="line" @click="toAddOrder('cmt')" w-path="">来料加工订单</div>
            </div>
          </div>
        </div>
        <div class="nav-item" v-if="userType == 2" :class="{active:'/list-take-order,/list-push-me'.search(currentPath)>-1}">
          <span >生产加工</span>
          <div class="dropdown">
            <div class="dropdown-inner">
              <div class="line" @click="toOrderList('1')" w-path="">接加工订单</div>
              <div class="line" @click="toOrderList('2')" w-path="">优先推送订单</div>
            </div>
          </div>
        </div>
        <router-link class="nav-item" to="/order" :class="{active:'/order'.search(currentPath)>-1}">
          <span>订单管理</span>
        </router-link>
        <div class="nav-item" @click="toDwSystem">
          <span>数字云仓</span>
        </div>
        <div class="nav-item" @click="toBrandOrderingSystem">
          <span>发布会订货系统</span>
        </div>
        <a class="nav-item" href="https://www.fzzht.com/solutions-ordering-conference.html" target="_blank">
          <span>订货</span>
        </a>
      </div>
      
      <div class="navbar-right">

        <div class="nav-item hover">
          <div class="avatar-box">
            <img class="avatar-img" v-if="userInfo.headImage" alt="" :src="userInfo.headImage"/>
          </div>
          <span class="avatar-title inaline">{{userInfo.companyName || phone}} 
            <!-- <i>{{userId}}</i>
            <span v-if="userType==1" class="red">品牌商-发单的</span>
            <span v-if="userType==2"  class="green">生产商-接单加工的</span> -->
          </span>
          <!-- 可删除 -->
          
          
          <div class="dropdown right">
            <div class="dropdown-inner">
              <div class="line" @click="toUserCenter">个人中心</div>
              <div class="line" @click="toAddressList">收货地址管理</div>
              <div class="line" @click="toQuit">退出登录</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="navbar-blank"></div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { toDwSystem, toBrandOrderingSystem } from '@/utils/freeLogin'

  export default {
    watch: {
        '$route': {
            handler: function(route) {
                // console.log(route)
                this.currentPath= route.path
                // console.log(this.currentPath)
            },
            immediate: true
        }
    },
    data(){
        return{
            currentPath:'',
        }
    },
    computed: {
      ...mapGetters(['userType', 'userIsAuth', 'userInfo', 'phone','userId','servicePhone'])
        
    },
    methods: {
      toDwSystem,
      toBrandOrderingSystem,
      toUserCenter() {
        this.$router.push('/user-center')
      },
      toAddressList() {
        this.$router.push('/address-list')
      },
      toQuit() {
        this.$store.dispatch('logOut', 1)
      },
      toAddOrder(type){
        if (this.userIsAuth == 'never') {
            this.$confirm('您还未认证企业信息，请先进行认证，才能发单', '企业未认证', {
                confirmButtonText: '去认证',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$router.push('/auth')
            })
        }
        if (this.userIsAuth == 'n') {
            this.$confirm('您的企业信息认证未通过，不能发单，请重新认证', '认证被拒绝', {
                confirmButtonText: '去认证',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$router.push('/auth')
            })
        }
        if (this.userIsAuth == 'p') {
            this.$confirm('您的企业信息认证审核中，认证通过后可以发单。可以拨打客服电话' + this.servicePhone +  '进行咨询', '认证审核中', {
                confirmButtonText: '确定',
                showCancelButton: false,
                type: 'warning'
            }).then(() => {
                // 确定
            })
        }
        if (this.userIsAuth == 'y') {
          if (type == 'oem') {
              this.$router.push('/addOem')
          } else if (type == 'cmt') {
              this.$router.push('/addCmt')
          }
        }
      },
      toOrderList(type) {
        if (type == '1') {
            this.$router.push('/list-take-order')
        } else if (type == '2') {
            this.$router.push('/list-push-me')
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .navbar {
      
    position: fixed;z-index:1000;
    width: 100%;
    height: 64px;
    background: #242424;
    color: #fff;
    box-sizing: border-box;
    min-width: 980px;
    .nav-item {
      position: relative;
      height: 64px;
      color: #fff;
      font-size: 16px;
      text-decoration: none;
      cursor: pointer;
      box-sizing: border-box;
      padding:0 10px;
      margin:0 10px;
      .ic {
        font-size: 18px;
        margin-right: 4px;
      }
    }
    .dropdown {
      overflow: hidden;
      height: 0;
      position: absolute;
      left: 50%;
      top: 64px;
      transform: translateX(-50%);
      &.right {
        left: auto;
        right: 0;
        transform: translateX(0);
      }
      .dropdown-inner {
        margin-top: 8px;
        transition: 0.2s;
        padding: 4px 12px;
        background: #fff;
        box-sizing: border-box;
        opacity: 0;
        min-width: 112px;
        background: #FFFFFF;
        box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
        border-radius: 2px;
        transform-origin: 50% 0;
        transform: scaleY(0);
      }
      .line {
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
      }
      .line.act, .line:hover {  
        color: #3F33FF;
      }
      
    }
    .nav-item:hover .dropdown {
      overflow: visible;
      height: auto;
    }
    .nav-item:hover .dropdown-inner {
      transform: scaleY(1);
      opacity: 1;
    }
    .navbar-left {
      float: left;
      font-size: 0;
      height: 64px;
      line-height: 64px;
      .logo-box {
        float: left;
        .logo {
          height: 26px;
          display: block;
          margin: 19px 24px 0;
        }
      }
      .nav-item {
        float: left;
      }
      .nav-item:hover::after, .nav-item.active::after {
        position: absolute;
        bottom: 0;
        left: 50%;
        content: ' ';
        width: 40px;
        height: 5px;
        margin-left: -20px;
        background: #3F33FF;
      }
    }
    .navbar-right {
      float: right;
      font-size: 0;
      height: 64px;
      .nav-item {
        padding-top: 16px;
      }

    }
    .avatar-box {
      display: inline-block;
      width: 32px;
      height: 32px;
      overflow: hidden;
      border-radius: 50%;
      background: url(../../../assets/images/avatar_default.png) no-repeat center/100% 100%;
      vertical-align: top;
      .avatar-img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        display: block;
        object-fit: cover;
      }
    }
    .avatar-title {
      display: inline-block;
      margin-left: 8px;
      max-width: 130px;
      font-size: 12px;
      line-height: 32px;
    }
    
  }
  .navbar-blank {
    height: 64px;
  }
</style>